// extracted by mini-css-extract-plugin
module.exports = {"button":"LabelElement__button___1ulAH","accordion-icon-wrapper":"LabelElement__accordion-icon-wrapper___LpLWR"};